import { z } from "zod";

export const editSKUSchema = z.object({
  product_name: z.string().min(1, "Required").max(255, "Max 255 characters"),
});

export type EditSKUFormValues = z.infer<typeof editSKUSchema>;
